import { Component, Input, OnInit } from '@angular/core';
import { ShareMessagesService, UtilService, VariablesService } from '../../../shared/services';

@Component({
  selector: 'app-telegram-share',
  templateUrl: './telegram-share.component.html',
  styleUrls: ['./telegram-share.component.scss']
})
export class TelegramShareComponent implements OnInit {

  @Input() isFundraiserEnded;

  constructor(
    private shareMessagesService: ShareMessagesService,
    private vars: VariablesService,
    private util: UtilService
  ) { }

  ngOnInit() {
  }

  async share() {
    const message = await this.shareMessagesService.getWhatsAppMessage(this.vars.fundraiser, this.vars.basicInfo, this.isFundraiserEnded);
    const url = `${this.util.domain_details.domain_url}/fundriaser/${this.vars.fundraiser.custom_tag}`;
    window.open(`https://t.me/share/url?url=${url}&text=${message}`, '_blank');
  }

}
